import React, { useState } from 'react';
import { Station, Plug } from '../types';

export default function StationResults({ stations }: { stations: Station[] }) {
  const [expandedId, setExpandedId] = useState<number | null>(null);
  const [showAll, setShowAll] = useState(false);

  if (!stations || stations.length === 0) return null;

  const visibleStations = showAll ? stations : stations.slice(0, 5);


  const statusBadge = (available: number | null | undefined, total: number) => {
    if (available === null || available === undefined) return '⚪ Status unknown';
    if (available > 0) return `🟢 ${available}/${total} available`;
    return `🔴 ${available}/${total} available`;
  };

  const plugSummary = (plugsArray: Plug[] | undefined) =>
    plugsArray?.map(p => `${p.Name} x${p.Count}`).join('  •  ') || '—';

  // Price is no longer sent at the station level — derive it from the first
  // plug's ChargingRate instead (falls back to legacy PriceString if present).
  const priceSummary = (plugsArray: Plug[] | undefined, legacyPriceString?: string) => {
    if (legacyPriceString) return legacyPriceString;
    const rate = plugsArray?.find(p => p.ChargingRate != null)?.ChargingRate;
    return rate != null ? `$${rate.toFixed(2)} / kWh` : '—';
  };

  // Network name moved from the station level to the plug level.
  const networkSummary = (plugsArray: Plug[] | undefined, legacyNetworkName?: string) =>
    legacyNetworkName || plugsArray?.find(p => p.NetworkName)?.NetworkName || 'Unknown';

  const lastUsedSummary = (plugsArray: Plug[] | undefined) => {
    const lastUsed = plugsArray?.find(p => p.LastTimeUsed)?.LastTimeUsed;
    return lastUsed || 'Usage history not available';
  };

  return (
    <div style={{ marginTop: 12 }}>
      <p style={{ fontWeight: 600, marginBottom: 8, color: 'var(--text-primary)' }}>
        Recommended Stations ({stations.length})
      </p>

      {visibleStations.map(s => (
        <div
          key={s.Id}
          onClick={() => setExpandedId(expandedId === s.Id ? null : s.Id)}
          style={{
            border: '1px solid var(--border-color)', borderRadius: 8,
            padding: 12, marginBottom: 8, background: 'var(--bg-elevated)', cursor: 'pointer'
          }}
        >
          <p style={{ fontWeight: 600, marginBottom: 4, color: 'var(--text-primary)' }}>{s.LocName}</p>
          <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 4 }}>{s.Address}</p>
          <p style={{ fontSize: 13, marginBottom: 4, color: 'var(--text-secondary)' }}>{plugSummary(s.PlugsArray)}  •  {priceSummary(s.PlugsArray, s.PriceString)}</p>
          <p style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{s.AccessTime}  •  {statusBadge(s.AvailablePorts, s.TotalPorts)}</p>

          {expandedId === s.Id && (
            <div style={{ marginTop: 10, borderTop: '1px solid var(--border-color)', paddingTop: 10, fontSize: 12, color: 'var(--text-secondary)' }}>
              <p><b>Network:</b> {networkSummary(s.PlugsArray, s.NetworkName)}  |  <b>Access:</b> {s.AccessType}  |  <b>Payment:</b> {s.PaymentMethods}</p>
              <p><b>Last Used:</b> {lastUsedSummary(s.PlugsArray)}{s.Web && <> {'  |  '} <a href={s.Web} target="_blank" rel="noreferrer" style={{ color: 'var(--accent)' }}>{s.Web}</a></>}</p>
            </div>
          )}
        </div>
      ))}
      {stations.length > 5 && (
    <button
    onClick={() => setShowAll(!showAll)}
    style={{
      marginTop: 8, padding: '6px 14px', borderRadius: 6,
      border: '1px solid var(--border-color)', cursor: 'pointer',
      background: 'var(--bg-elevated)', color: 'var(--text-primary)', width: '100%'
    }}
  >
    {showAll ? 'Show less ↑' : `Show more stations (${stations.length - 5} more) ↓`}
  </button>
)}

    </div>
  );
}
